<template>
<div class="container" >

  <waitingModal v-if="waitModal.show" @close="closeWaitingModal()"  v-bind:props="waitModal"></waitingModal>
  <div class="card border-primary">
      <div class="card-header bg-primary text-white">
        <strong><h4>
          <i class="fas fa-cash-register mr-2" aria-hidden="true"></i>   
          STAMPANTE FISCALE</h4></strong>
      </div>
      <div class="card-body">
        <form v-on:submit.prevent="submit()">
            <deskCounter class="mt-1 mb-3" @setDesk="setDeskCounter"></deskCounter>
            <div class="form-group">
              <label for="exampleFormControlSelect1"><strong>MODELLO</strong></label>
              <select  v-model="fp.fpId" @change=setFP($event.target.selectedIndex)  class="form-control" id="exampleFormControlSelect1">
                <option value="-1"> *** NESSUNA STAMPANTE FISCALE *** </option>  
                <option  v-for="(option,index) in fpList" :key="index" :value="option.fpId">
                      {{ option.text  }}
                  </option>
              </select>
            </div>  

            <div v-if="fp.fpId >-1">
            
            <div v-if="fp.ip" class="form-group">
              <!--
              <select  @change=setProtocol($event.target.selectedIndex)  class="form-control" id="exampleFormControlSelect0">
                <option  v-for="(option,index) in protocol" :key="index" :value="option.text">
                      {{ option.text  }}
                  </option>
              </select>
              -->

              <label for="exampleFormControlInput1"><strong>INDIRIZZO IP</strong></label>
              <input required v-model="fp.url" type="text" class="form-control" id="exampleFormControlInput1" placeholder="Indirizzo IP">
              <small>Inserire protocollo e indirizzo per es. http://192.168.1.230</small>
            </div>

            <div  class="form-group">
              <label for="exampleFormControlInput2"><strong>MATRICOLA</strong></label>
              <input required v-model="fp.badge" type="text" class="form-control" id="exampleFormControlInput2" placeholder="Matricola">
            </div>
            <div class="form-group">
              <div class="form-check">
                <input v-model="fp.active" class="form-check-input" type="checkbox" id="gridCheck">
                <label class="form-check-label" for="gridCheck">
                  <strong>MOSTRA RICHIESTA STAMPA ALLA VENDITA</strong>
                </label>
              </div>
            </div>
            
            </div>
            <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
            <button   :disabled="bt_spinner" type="submit" class="btn btn-primary float-right">
                  <i class="fas fa-save mr-2" aria-hidden="true"></i>   
                  MODIFICA 
                  <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
            </button>

        </form>
        
      </div>
  </div>

</div>

</template>
<script>

import { mapGetters }    from 'vuex'
import api               from "@/api"
import alertBox          from '@/components/common/AlertBox.vue'
import deskCounter       from '@/components/common/Desk.vue';
import waitingModal      from "@/components/common/WaitingModal.vue"

export default {
  components: {alertBox,deskCounter,waitingModal},
  data() {
    return {
      

      waitModal    : {

        sentinel   : 0,
        show       : false,
        msg1       : 'ELABORAZIONE IN CORSO ...',
        msg2       : '' 

      },

       bt_spinner : false,
       protocol   : [{'text':'HTTP'},{'text':'HTTPS'}],
       fp         : {'fpId':-1},
       //fp         : {'fpId':-1,'ip':0},
       deskId     : 1,
      
       msg    : 
       {
           title     : '',
           body      : '',
           type      : 0
       },
       fpList   : []

    };
  },

  computed :{
    ...mapGetters(['company','storeId']),    
   
  },
  mounted : function()
  {
    const deskId = JSON.parse(localStorage.getItem("deskId"))
    
    if(deskId)
    {    
      this.deskId = Number(deskId)
    }
  },
  created : function()
  {
    this.getFiscalPrinter()
    //this.getData()
  },
  methods: {

    setDeskCounter(deskId)
    {
      

      this.deskId = deskId
      //localStorage.setItem('deskId',JSON.stringify(deskId))

      this.getData()

    },
    setData(index)
    {
      
      if(index)
      {
        
        this.fp.fpId    = this.fpList[index - 1].fpId
        this.fp.ip      = this.fpList[index - 1].ip
        const url       = this.fp.ip ? this.fp.url : ''
        this.fp.url     = url
        this.fp.type    = this.fpList[index - 1].type
        
      }
      else
      {
        this.fp.fpId    = -1
        this.fp.ip      = 0
        this.fp.badge   = ''
        this.fp.active  = false
        this.fp.url     = ''
       
      }
      
    },
    setFP(index)    
    {
      
      this.msg.title = ''
      this.setData(index)
          
    },

    
    async getFiscalPrinter() {
                      
            this.msg.title = ''
            const sp = {'sp' : 'spFiscalPrinter'}      
            
           
            const json  = Object.assign(sp)
            //this.spinner = true
            await api.post(json).then(res => {
                
                
                if(res.status==200)
                  {
                    
                    if(res.data.recordsets[0].length == 0)
                    {
                     
                      this.msg.title = 'ATTENZIONE '
                      this.msg.body  = 'DATI INESISTENTI.'
                      this.msg.type  = 1
                      return
                    }
                   
                    this.fpList = res.data.recordsets[0]
                   
                    
                  }
                  else if (res.status==500)
                  { 
                    console.log('err')             
                    this.msg.title = 'ATTENZIONE '
                    this.msg.body  = res.data
                    this.msg.type  = 1
                    
                  }
              
                else
                {
                       
                  this.msg.title = 'ATTENZIONE '
                  this.msg.body  = res
                  this.msg.type  = 1
                              
      
                }
            }).catch(err=>{
                               
                  this.msg.title = 'ATTENZIONE '
                  this.msg.body  = err.message
                  this.msg.type  = 1
              
      
            }).finally(() => {
                //this.spinner = false
              });
            
      
      
      
      
          },
        
    closeWaitingModal()
    {
      this.waitModal.show = false
      this.waitModal.sentinel = 0
      
    },      

    async getData() {
            
     
     // this.fp.storeId = this.storeId
     // this.fp.deskId  = this.deskId
      
      this.msg.title = ''
      const sp    = {'sp' : 'spStoreDeskFiscalPrinter'}      
      const data  = {
          'storeId' :this.storeId,'deskId': this.deskId
      }
      
      const json  = Object.assign(data, sp)
    
      //this.spinner = true
      this.waitModal.show = true

      await api.post(json).then(res => {                    
          if(res.status==200)
            {
              this.waitModal.sentinel = 1 
             
              if(res.data.recordsets[0].length == 0)
              {
                /*
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = 'DATI INESISTENTI.'
                this.msg.type  = 1
                */
                
                this.fp = {'fpId': -1}
              
                return 
              }
              

              this.fp       = res.data.recordsets[0][0]
              const result  = this.fp.url.indexOf("http")              
              this.fp.ip    = result > -1 ? 1 : 0
             

            }
            else if (res.status==500)
            { 
              this.waitModal.sentinel = 3             
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
            }
        
          else
          {

            this.waitModal.sentinel = 2

            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
                        

          }
      }).catch(err=>{
        
            
            this.waitModal.sentinel = 3
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1
        

      }).finally(() => {
          //this.spinner = false
        });
      




    },
    async submit() {
      

      this.fp.storeId = this.storeId
      this.fp.deskId  = this.deskId
      this.bt_spinner = true
      this.msg.title  = ''
      
      const sp        = {'sp' : 'spUpdateStoreDeskFiscalPrinter'}                           
      const data      = this.fp
      const json      = Object.assign(data,sp)
      await api.post(json).then(res => {
                          
      if(res.status==200)
      {
                              
        this.msg.title = 'MODIFICA STAMPANTE FISCALE EFFETTUATA.'
        this.msg.body  = ''
        this.msg.type  = 0
                                                              
      }
      else if (res.status==500)
      { 
      
        this.msg.title = 'ATTENZIONE '
        this.msg.body  = res.data
        this.msg.type  = 1
      }
                        
      else
      {
        this.msg.title = 'ATTENZIONE '
        this.msg.body  = res
        this.msg.type  = 1
      }
      }).catch(err=>{
        this.msg.title = 'ATTENZIONE '
        this.msg.body  = err.message
        this.msg.type  = 1
        }).finally(() => {
          this.bt_spinner = false
        });
                                      
  },
              
  
  }
};
</script>
<style scoped>
h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.form-check-label{
  cursor:pointer
}
</style>